import Style from "./EnterpriseTextConfigStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import api from "../../../services/api";

import { useEffect, useState } from "react";
import PageTitle from "../../../components/PageTitle";

export default function EnterpriseTextConfig(props) {

  const [textConfigs, setTextConfigs] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("")
  const enterpriseId = props.match.params.enterpriseId;

  useEffect(() => {
    LoadTextConfigs();
  }, []);


  async function LoadTextConfigs() {
    setLoading(true);
    try {

      const result = await api.get(`/enterprises/textConfigs/${enterpriseId}`);
      if (!result.data.success) {
        console.error("Erro: ", result.data);
        setErrorMessage("Não foi possível consultar configurações de texto!");
        setSuccessMessage("");
        setLoading(false);
        return;
      }

      setErrorMessage("");
      const text = result.data.enterpriseTextConfigs;
      setTextConfigs(text);
    }
    catch (error) {
      console.error("Erro consultando configurações de texto: ", error);
      setErrorMessage("Não foi possível carregar as páginas");
    }

    finally {
      setLoading(false);
    }
  }

  function GoToTextConfigPage(pageId: number) {
    props.history.push(`/enterprises/${enterpriseId}/textConfigs/${pageId}`);
  }

  return (
    <Style>
      <PageTitle title="Informações do empreendimento" />
      <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
      <Spinner spinning={loading} />
      {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}
      <section className="table-title">
        <h1>Configuração de telas gerais</h1>
      </section>
      
      <table className="table table-striped table-bordered table-hover main-table">
        <thead>
          <tr>
            <th>Página</th>
            <th>Titulo</th>
            <th>Descrição</th>
          </tr>
        </thead>
        {textConfigs !== null &&<tbody>
              <tr>
                <td>Informações de Contato:</td>
                <td onClick={() => GoToTextConfigPage(textConfigs.id)} className="clickable">{textConfigs.contactTitle}</td>
                <td onClick={() => GoToTextConfigPage(textConfigs.id)} className="clickable">{textConfigs.contactDescription}</td>
              </tr>
              <tr>
                <td>Notas Gerais</td>
                <td onClick={() => GoToTextConfigPage(textConfigs.id)} className="clickable">{textConfigs.notesTitle}</td>
                <td onClick={() => GoToTextConfigPage(textConfigs.id)} className="clickable">{textConfigs.notesDescription}</td>
              </tr>
        </tbody>}
      </table>
    </Style >

  )
}